import { useState } from "react";
import WorkspaceModal from "./components/workspaceModal/WorkspaceModal";
import { Box } from "@chakra-ui/react";
import Header from "./components/landingPage/Header";
import CallToAction from "./components/landingPage/CallToAction";
import Footer from "./components/landingPage/Footer";

const CreateWorkspace = () => {
    const [isOpenWorkspace, setIsOpenWorkspace] = useState(true);
    return(
        <>
        <Box className="workspaceHeader">
            <Header />
        </Box>
        <Box className="workspaceModalMain">
        <WorkspaceModal onCloseWorkspace={() => setIsOpenWorkspace(false)} isOpenWorkspace={isOpenWorkspace} />
        </Box>
       <Box className="workspaceFooter">
         <CallToAction />
        <Footer />
       </Box>
        </>
    )
}
export default CreateWorkspace;